import { DateTime } from 'luxon';

const makeZeroOffset = (date: DateTime) =>
  date.set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toISO({ includeOffset: false });

export const addClassNameToDate = (
  range: Date | [Date | null, Date | null] | null | undefined,
  isUpdate?:boolean,
  openedDate?: string,
) =>
  (props: {
    activeStartDate: Date
    date: Date
  }) => {
    if (!isUpdate) {
      return '';
    }

    const [start, end] = range as [Date, Date];
    const zeroDate = makeZeroOffset(DateTime.fromJSDate(props.date));
    const zeroOpenedDate = makeZeroOffset(DateTime.fromISO(openedDate ?? '', { setZone: true }));
    const zeroStartRange = makeZeroOffset(DateTime.fromJSDate(start));
    const zeroEndRange = makeZeroOffset(DateTime.fromJSDate(end));

    if (zeroDate === zeroOpenedDate) {
      return 'opened-date';
    }

    if (zeroDate === zeroStartRange) {
      return 'custom-start-range';
    }

    if (zeroDate === zeroEndRange) {
      return 'custom-end-range';
    }

    return '';
  };
